import $ from "jquery";

class GlobalUtils {

    // 1.- Describe and create/initate our object
    constructor() {
        this.allied_div = $("#allied_div");
        this.alliedGreenBar = $("#alliedGreenBar");

        this.patients_div = $("#patients_div");
        this.patientsGreenBar = $("#patientsGreenBar");

        this.payers_div = $("#payers_div");
        this.payersGreenBar = $("#payersGreenBar");

        this.events();
    }

    // 2.- events
    events() {
        this.allied_div.on("mouseover", this.allied_growBar.bind(this));
        this.allied_div.on("mouseout", this.allied_resetBar.bind(this));

        this.patients_div.on("mouseover", this.patients_growBar.bind(this));
        this.patients_div.on("mouseout", this.patients_resetBar.bind(this));

        this.payers_div.on("mouseover", this.payers_growBar.bind(this));
        this.payers_div.on("mouseout", this.payers_resetBar.bind(this));
    }

    // 3.- methods (function, action...)
    allied_growBar(){
        this.alliedGreenBar.addClass("grow");
    }
    allied_resetBar(){        
        this.alliedGreenBar.removeClass("grow");        
    }


    patients_growBar(){
        this.patientsGreenBar.addClass("grow");
    }
    patients_resetBar(){        
        this.patientsGreenBar.removeClass("grow");        
    }


    payers_growBar(){
        this.payersGreenBar.addClass("grow");
    }
    payers_resetBar(){        
        this.payersGreenBar.removeClass("grow");        
    }

}

export default GlobalUtils;